import { useState } from 'react'
import { motion } from 'framer-motion'
import { Check, Link2, MessageCircle } from 'lucide-react'

const SITE_URL = process.env.REACT_APP_SITE_URL
const SHARE_TEXT = `Found a food & wellness brand that promises to skip the bluff. Launching soon — join the early list with me: ${SITE_URL}`

export default function ShareNudge({ testIdPrefix }) {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(SITE_URL)
    } catch {
      const el = document.createElement('textarea')
      el.value = SITE_URL
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }
    setCopied(true)
    setTimeout(() => setCopied(false), 2200)
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="mx-auto mt-12 flex max-w-md flex-col items-center gap-3.5"
      data-testid={`${testIdPrefix}-share-nudge`}
    >
      <p className="text-[0.85rem] text-haze" data-testid={`${testIdPrefix}-share-prompt`}>
        Know someone who's tired of the bluff? Tell a friend.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2.5">
        <a
          href={`https://wa.me/?text=${encodeURIComponent(SHARE_TEXT)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="share-chip"
          data-testid={`${testIdPrefix}-share-whatsapp`}
        >
          <MessageCircle size={14} strokeWidth={2.2} />
          WhatsApp
        </a>
        <button type="button" onClick={copy} className="share-chip" data-testid={`${testIdPrefix}-share-copy`} aria-live="polite">
          {copied ? <Check size={14} strokeWidth={2.6} /> : <Link2 size={14} strokeWidth={2.2} />}
          {copied ? 'Copied' : 'Copy link'}
        </button>
      </div>
    </motion.div>
  )
}
